import React from 'react';
import { useSelector } from 'react-redux';
import { RootState as C_RootState } from '@Redux/common/store';
import cN from 'classnames';
import { Info } from '@components/Common/Icons';
import styles from '../style.module.scss';

interface I_Props {
    dailyItem: any;
}

const DayIntro: React.FC<I_Props> = ({ dailyItem }) => {
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);
    return (
        <>
            <div className={styles.imgDay}>
                <div>DAY</div>
                <div>{dailyItem.Day}</div>
            </div>
            <div className={styles.daySchedule}>
                <h3
                    className={cN({ [`${styles.printModeTitle}`]: curPage === 'print' })}
                    dangerouslySetInnerHTML={{ __html: dailyItem.TravelPoint! }}
                />
                {dailyItem.SpecialNote && (
                    <div className={styles.note}>
                        <Info fill="#3ea5d9" />
                        <span dangerouslySetInnerHTML={{ __html: dailyItem.SpecialNote }} />
                    </div>
                )}
                {dailyItem.Summary && (
                    <div
                        className={styles.summary}
                        dangerouslySetInnerHTML={{ __html: dailyItem.Summary }}
                    />
                )}
            </div>
        </>
    );
};

export default DayIntro;
